import React, { Component } from 'react'
import { reduxForm } from 'redux-form'
import { shape } from 'prop-types'
import {
  CrmTextInput,
  CrmFormSection,
  CrmButton,
  CrmValidatedField
} from 'crm-components'

class MeSettingsForm extends Component {
  render() {
    const { handleSubmit } = this.props
    return (
      <form onSubmit={handleSubmit}>
        <CrmFormSection sectionName="Change password">
          <fieldset className="Form-fieldset CrmForm-form-fieldset">
            <div className="row">
              <div className="col-xs-12 col-md-12">
                <CrmValidatedField
                  component={CrmTextInput}
                  componentProps={{
                    placeholder: 'New Password'
                  }}
                  name="new_password"
                  type="password"
                />

                <CrmValidatedField
                  component={CrmTextInput}
                  componentProps={{
                    placeholder: 'Confirm password'
                  }}
                  name="confirm_password"
                  type="password"
                />

                <CrmButton
                  label="Change password"
                  onClick={this.handleChangePassword}
                  type="submit"
                />
              </div>
            </div>
          </fieldset>
        </CrmFormSection>
      </form>
    )
  }
}

MeSettingsForm.propTypes = {
  handleSubmit: shape({}).isRequired
}

const MeSettingsFormRedux = reduxForm({
  form: 'crmMeSettingForm',
  enableReinitialize: false
})(MeSettingsForm)

export default MeSettingsFormRedux
